module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main